import { useDealItemPicker } from './DealItemPicker';
import { classNames } from 'libs/react';
import { FormSection } from 'components/form/FormSection';
import { React } from 'libs/react';
import { DealItemPickerConfigTable } from './DealItemPickerConfigTable';
import './DealItemPickerConfigPane.scss';
/**
 * @component DealItemPickerConfigPane
 * @since 1.0.0
 */
export function DealItemPickerConfigPane(props) {
    var _a;
    const { style } = Object.assign({ style: 'normal' }, props);
    const { item } = useDealItemPicker();
    const className = classNames('deal-item-picker-config-pane', 'deal-item-picker-config-pane--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(FormSection, { title: t('Specifications') },
            React.createElement(DealItemPickerConfigTable, { values: (_a = item === null || item === void 0 ? void 0 : item.variants) === null || _a === void 0 ? void 0 : _a.filter((variant) => variant.active), ready: !!item }))));
}
